<template>
  <div class="service-detail">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面内容 -->
    <section class="service-content">
      <div class="container">
        <div class="breadcrumb">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <router-link to="/services">服务支持</router-link>
          <span>/</span>
          <span class="current">{{ service.title || '服务详情' }}</span>
        </div>
        <h1>{{ service.title || '服务详情' }}</h1>
        <div v-if="service.contentAll" v-html="service.contentAll"></div>
        <div v-else>
          <p>加载中...</p>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "ServiceDetail",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
  data() {
    return {
      service: {
        title: '',
        contentAll: ''
      }
    };
  },
  mounted() {
    this.fetchServiceDetail();
  },
  methods: {
    fetchServiceDetail() {
      const serviceId = this.$route.query.id;
      if (serviceId) {
        // 调用获取服务列表的接口，然后根据ID过滤
        api.get("/api/service/getServiceList")
          .then(response => {
            if (response.data.code === 0) {
              const service = response.data.data.find(s => s.id == serviceId);
              if (service) {
                this.service = service;
              }
            }
          })
          .catch(() => {
            // 静默处理错误
          });
      }
    }
  }
};
</script>

<style scoped>
.service-detail {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 服务详情 */
.service-content {
  padding: 4rem 0;
}

.breadcrumb {
  margin-bottom: 2rem;
  font-size: 0.9rem;
  color: #666;
}

.breadcrumb a {
  color: #007bff;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb span {
  margin: 0 0.5rem;
}

.breadcrumb .current {
  color: #333;
  font-weight: bold;
}

.service-content h1 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .service-content h1 {
    font-size: 2rem;
  }
}
</style>
